export { default } from './useSessionStorage';
